module.exports = __webpack_public_path__ + "media/images/wfc/venue-7-a44249c7357937334af36cb321436430.jpg";